import { Icon } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const Step = ({ step, text, activeStep, completed, goToStep, withNavigation }) => {
    const { t } = useTranslation();
    const isActive = activeStep === step;
    const isClickable = withNavigation && goToStep;
    const borderClass = isActive || completed ? 'border-action-primary-initial' : 'border-neutral-primary-initial';
    const iconColorClass = isActive || completed ? 'fill-icon-action-primary-initial' : 'fill-icon-neutral-primary-initial';
    const getIconName = () => {
        if (completed)
            return 'check_circle';
        if (isActive)
            return 'incomplete_normal_sharp';
        return 'circle_dash_sharp';
    };
    return (<li className={`flex-1 min-w-40 border-b-2 ${borderClass} ${isClickable ? 'cursor-pointer' : ''}`} onClick={() => isClickable && goToStep(step)}>
            <div className="flex flex-col gap-0.5 py-4">
                <div className="flex items-center gap-2">
                    <Icon name={getIconName()} size="md" className={iconColorClass}/>
                    <p data-testid={`stepper-step-${step}-name`} className={`label-m truncate ${isActive || completed ? 'text-neutral-primary-initial' : 'text-neutral-secondary-initial'}`}>
                        {text}
                    </p>
                </div>
                <p data-testid={`stepper-step-${step}-number`} className="body-s text-neutral-secondary-initial pl-[26px]">
                    {t('financing.stepper.step', { number: step })}
                </p>
            </div>
        </li>);
};
const Stepper = ({ activeStep, steps, goToStep, withNavigation }) => (<ol className="flex flex-col md:flex-row">
        {steps.map(({ step, text, completed }) => (<Step key={step} step={step} text={text} activeStep={activeStep} completed={completed} goToStep={goToStep} withNavigation={withNavigation}/>))}
    </ol>);
export default Stepper;
